<template>
  <div style="display: flex; flex-direction: row; justify-content: space-between; height: 100vh; width: 100%; background: linear-gradient(rgb(255, 255, 255) 0%, rgb(232, 240, 254, 0.5) 100%)">
    <!-- 右侧子界面 -->
    <div style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: start; box-sizing: border-box">
      <div class="breadcrumb-container">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <a @click="goBackToPreviousPage" class="breadcrumb-link">论文选题协助</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>选题结果</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 内容区域 -->
      <div style="display: flex; flex-direction: row; justify-content: center; margin: auto; width: 100%; flex: 1; overflow-y: auto">
        <TopicAssistantResultWorkBench :content="workbenchContent" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import TopicAssistantResultWorkBench from "../components/TopicAssistantResultWorkBench.vue";

export default {
  name: "TopicAssistantResult",
  components: {
    TopicAssistantResultWorkBench,
  },
  data() {
    return {
      workbenchContent: null,
    };
  },
  mounted() {
    // 从本地存储获取选题结果数据
    const savedContent = sessionStorage.getItem("topic_assistant_result");
    if (savedContent) {
      this.workbenchContent = JSON.parse(savedContent);
    }
  },
  methods: {
    goBackToPreviousPage() {
      const savedContext = sessionStorage.getItem("topic_assistant_back_context");
      if (savedContext) {
        sessionStorage.setItem("pending_history_conversation", savedContext);
      }
      this.$router.push({ path: "/topic-assistant" }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.breadcrumb-container {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.breadcrumb-link {
  color: #409eff;
  cursor: pointer;
  text-decoration: none;
}

.breadcrumb-link:hover {
  color: #66b1ff;
}
</style>
